import React, { ReactNode } from 'react';
import { Redirect } from 'react-router-dom-v5';
import { PageWithNavigation, Section } from '@/src/components';
import { ROUTE_HOME } from '@/src/constants/routes';
import {
  AccountBillingType,
  useAccountBillingType,
} from '@/src/hooks/useAccountBillingType';
import SiteLoading from '../Wrapper/SiteLoading';

type Props = {
  allow: Exclude<AccountBillingType, 'PAYX'>;
  children: ReactNode;
};

export const BillingTypeRouteGuard = ({ allow, children }: Props) => {
  const accountBillingType = useAccountBillingType();

  if (accountBillingType.isLoading) {
    return (
      <PageWithNavigation title="">
        <Section>
          <SiteLoading />
        </Section>
      </PageWithNavigation>
    );
  }

  if (accountBillingType.data?.type !== allow) {
    return <Redirect to={ROUTE_HOME} />;
  }

  return children;
};
